module.exports = __webpack_public_path__ + "static/media/744.f4a5a51f.jpg";